// import { get } from "core-js/core/dict"

export default {
  state() {
    return {
      orderDetail: undefined,
      orderComplete: undefined,
      order: undefined,
      orderCancel: undefined,
      menuBasicInfo: {},
      orderPublicStay: {},
      dataItemPublicStay: undefined,
      completeOrderPublicStay: undefined,
      orderConfirm: null,
      originCalendar: null,
      subsidyAvailables: [],
      orderId: null,
      payeeDivMethod: undefined,
    }
  },
  getters: {
    get(state) {
      return state
    }
  },
  mutations: {
    set(state, data) {
      state.orderDetail = data
    },
    setOrderComplete(state, data) {
      state.orderComplete = data
    },
    setOrder(state, data) {
      state.order = data
    },
    setOrderCancel(state, data) {
      state.orderCancel = data
    },
    setMenuInfo(state, payload) {
      state.menuBasicInfo = payload
    },
    setOrderPublicStay(state, payload) {
      state.orderPublicStay = payload
    },
    setDataItemPublicStay(state, payload) {
      state.dataItemPublicStay = payload
    },
    setCompleteOrderPublicStay(state, payload) {
      state.completeOrderPublicStay = payload
    },
    setOrderConfirm(state, payload) {
      state.orderConfirm = payload
    },
    setOriginCalendar(state, payload) {
      state.originCalendar = payload
    },
    setSubsidyAvailables(state, payload) {
      state.subsidyAvailables = payload
    },
    setOrderId(state, payload) {
      state.orderId = payload
    },
    setPayeeDivMethod(state, payload) {
      state.payeeDivMethod = payload
    },
    setResetState(state) {
      state.menuBasicInfo = {}
      state.orderPublicStay = {}
      state.dataItemPublicStay = undefined
      state.completeOrderPublicStay = undefined
      state.orderConfirm = null
      state.originCalendar = null
      state.subsidyAvailables = []
      state.orderId = null
      state.payeeDivMethod = undefined
    }
  },
  actions: {
    set({commit}, payload) {
      commit('set', payload)
    },
    getOrderDetail() {
      return this.state.orderDetail
    },
    setOrderConfirm({ commit }, payload) {
      commit('setOrderConfirm', payload)
    },
    setOrderComplete({commit}, payload) {
      commit('setOrderComplete', payload)
    },
    getOrderComplete() {
      return this.state.orderComplete
    },
    setOrder({commit}, payload) {
      commit('setOrder', payload)
    },
    getOrder() {
      return this.state.order
    },
    setOrderCancel({commit}, payload) {
      commit('setOrderCancel', payload)
    },
    getOrderCancel() {
      return this.state.orderCancel
    },
    setOriginCalendar({commit}, payload) {
      commit('setOriginCalendar', payload)
    },
    setSubsidyAvailables({commit}, payload) {
      commit('setSubsidyAvailables', payload)
    },
    setOrderId({commit}, payload) {
      commit('setOrderId', payload)
    },
    setPayeeDivMethod({commit}, payload) {
      commit('setPayeeDivMethod', payload)
    },
  }
}
